import { List } from "antd";
import useFormInstance from "antd/es/form/hooks/useFormInstance";
import { OpForm } from "components/customAntd/DLS/OpForm/OpForm";
import { useTranslation } from "react-i18next";

interface OptionsFormProps {
    entryIdOptions: { value: number; label: string }[];
}


const OptionsForm: React.FC<OptionsFormProps> = ({ entryIdOptions }) => {
    const form = useFormInstance();
    const qrEnabled = OpForm.useWatch('qrEnabled', form) || false;
    const entryEnabled = OpForm.useWatch('entryEnabled', form) || false;

    const { t } = useTranslation();
    return (
        <>
            <List
                header={t('avigilonReader.form.readerOptionsTitle')}
                bordered
                style={{ marginBottom: "16px", padding: "12px", borderRadius: "8px" }}
            >
                <List.Item style={{ width: "100%" }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <OpForm.Switch
                            name="qrEnabled"
                            checked={qrEnabled}
                            onChange={(checked) => {
                                if (!checked) {
                                    form.setFieldsValue({
                                        entryEnabled: false,
                                        autoSignIn: false
                                    });
                                }
                            }} />
                        <span style={{ marginLeft: 8 }}>{t('avigilonReader.form.recognizeQR')}</span>
                    </div>
                </List.Item>


                <List.Item style={{ width: "100%", flexDirection: "column", alignItems: "flex-start" }}>
                    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <OpForm.Switch
                            name="entryEnabled"
                            disabled={!qrEnabled}
                            onChange={(checked) => {
                                if (!checked) {
                                    form.setFieldsValue({
                                        autoSignIn: false
                                    });
                                }
                            }}
                        />
                        <span style={{ marginLeft: 8 }}>{t('avigilonReader.form.entryOnQR')}</span>
                    </div>
                    <div style={{ width: "100%", marginTop: "8px" }}>
                        <OpForm.Select
                            name="entryId"
                            placeholder={t('avigilonReader.form.entryIdPlaceholder')}
                            disabled={!entryEnabled}
                            options={entryIdOptions}
                        />
                    </div>
                </List.Item>

                <List.Item style={{ width: "100%" }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <OpForm.Switch
                            name="autoSignIn"
                            disabled={!entryEnabled}
                        />
                        <span style={{ marginLeft: 8 }}>{t('avigilonReader.form.autoSignIn')}</span>
                    </div>
                </List.Item>
            </List>
        </>
    );
};

export default OptionsForm;
